/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_AmountInputs */

const vi_dashboard_driver_next_stop_amount = /** @type {(inputs: Dashboard_Driver_Next_Stop_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền`)
};

/**

* @param {Dashboard_Driver_Next_Stop_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_amount = /** @type {((inputs?: Dashboard_Driver_Next_Stop_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_amount(inputs)
});